import React from "react";
import "./ChatbotWidget.scss";

const CHATBOT_URL = "https://d1x8svzs28gqii.cloudfront.net";

const ChatbotWidget = () => {
  return (
    <iframe
      title="KB Chatbot"
      src={CHATBOT_URL}
      className="chatbot-widget-frame"
      allow="clipboard-write"
    />
  );
};

export default ChatbotWidget;
